import React from 'react';
// utils
// settings
// icons
// components
//
//
//
import StartColumnsContainer from 'modules/emergencies/components/ui/containers/startColumnsContainer';
import EndColumnsContainer from 'modules/emergencies/components/ui/containers/endColumnsContainer';
//
//
import BodyRow from 'modules/emergencies/components/ui/rows/bodyRow';
import { TicketColumn } from '../columns/TicketColumn';
import { LocationsColumn } from '../columns/LocationsColumn';
import { CarrierColumn } from '../columns/CarrierColumn';
import { RequirementsColumn } from '../columns/RequirementsColumn';
import { OwnerAgentColumn } from '../columns/OwnerAgentColumn';
import { ShipperColumn } from '../columns/ShipperColumn';
import { ServiceTypeColumn } from '../columns/ServiceTypeColumn';
import { QuoteColumn } from '../columns/QuoteColumn';
import ActionsColumn from '../columns/ActionsColumn';
import { useSelector } from 'react-redux';
import {
  constants,
  getSpecificClientConfig,
} from '../../../../../../redux/modules/client-config/selectors';
import { InternalCommentColumn } from '../columns/InternalCommentColumn';
import { InternalCommentMessageColumn } from '../columns/InternalCommentMessageColumn';
const TicketsListTableTicketRow = ({ ticket, reset }) => {
  const actionsEnabled = useSelector((state) =>
    getSpecificClientConfig(state, constants.TICKET_LIST_ACTIONS_ENABLED)
  );

  return (
    <>
      <BodyRow key={ticket.id}>
        <StartColumnsContainer>
          <TicketColumn ticket={ticket} />
          <ShipperColumn ticket={ticket} />
          <LocationsColumn ticket={ticket} />
          <ServiceTypeColumn ticket={ticket} />
          <CarrierColumn ticket={ticket} />
          <QuoteColumn ticket={ticket} />
          <RequirementsColumn ticket={ticket}></RequirementsColumn>
        </StartColumnsContainer>
        <EndColumnsContainer>
          <InternalCommentMessageColumn ticket={ticket} />
          <InternalCommentColumn ticket={ticket} />
          <OwnerAgentColumn ticket={ticket} reset={reset}></OwnerAgentColumn>
          {actionsEnabled && <ActionsColumn ticket={ticket} />}
        </EndColumnsContainer>
      </BodyRow>
    </>
  );
};

export default TicketsListTableTicketRow;
